import { useBackend } from "../../services";

export const useGetAppleSubscriptionByEmail = () => {
  const { get } = useBackend();
  return async (props: { email: string }) => get("admin/subscription/apple", props);
};
